import React, { FC } from 'react';

import { NotLoggedLayout } from 'src/layouts';

export const FreeTrialWrapper: FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  return (
    <NotLoggedLayout>
      <div className="flex min-h-screen w-full items-center justify-center px-4 pb-8">
        <div className="flex w-full max-w-lg flex-col items-center py-16">
          <img
            alt="logo"
            width="305"
            height="50"
            className="mb-8"
            src={`${process.env.PUBLIC_URL}/logo-white.svg`}
          />
          <div className="rounded-lg bg-hx-panel w-500 px-12 pb-12 pt-8 flex flex-col items-center justify-center">
            <div className="flex flex-col items-center justify-center gap-4 w-full">
              {children}
            </div>
          </div>
        </div>
      </div>
    </NotLoggedLayout>
  );
};
